import { render, staticRenderFns } from "./messagesMenu.vue?vue&type=template&id=667aef02&scoped=true&"
import script from "./messagesMenu.vue?vue&type=script&lang=js&"
export * from "./messagesMenu.vue?vue&type=script&lang=js&"
import style0 from "./messagesMenu.vue?vue&type=style&index=0&id=667aef02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667aef02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAvatar,VBadge,VBtn,VChip,VIcon,VImg,VSheet,VSlideXTransition})
